import { useI18n } from "@/contexts/I18nContext";

/**
 * Tiny inline translation helper — use inside any component:
 *
 *   const t = useT();
 *   <h1>{t("Përshëndetje", "Hello")}</h1>
 *
 * Returns the Albanian string on `sq`, the English one on `en`.
 * Falls back to Albanian when English is missing.
 */
export function useT() {
  const { lang } = useI18n() || {};
  return (sq, en) => (lang === "en" && en ? en : sq);
}
